import ProductItem from 'components/Product/ProductItem/ProductItem';
import { withProductItemProps } from 'viewModel/product/productItem/withProductItemProps';

export default withProductItemProps(ProductItem);
